<template>
  <div>
    <AppBar :heading-sections="sectionsHeaders"></AppBar>
    <v-main>
      <ParallaxAlumnier></ParallaxAlumnier>
      <section :id="singleSection.headerAnchor">
        <AppearContentScroll
          :image="singleSection.image"
          :header="singleSection.header"
          :twist="singleSection.id%2===0"
        >
          <template v-slot:content>
            <div class="pt-sm-0 pt-4">
              <h3
                  :class="[{'text-h4': !$vuetify.breakpoint.mobile, 'text-h5': $vuetify.breakpoint.mobile}]"
              >
                {{singleSection.content.headline}}
              </h3>
              <p class="subtitle-1 mt-3">{{singleSection.content.subtext}}</p>
              <v-list class="" dense>
                <v-list-item class="py-0" v-for="(item, i) in singleSection.content.items" :key="i">
                  <v-list-item-icon>
                    <v-icon color="success">mdi-check</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="">
                    {{item}}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
          </template>
        </AppearContentScroll>
      </section>
      <section>
        <AppearBoxesScroll />
      </section>
      <section v-for="section in sectionsContent" :key="section.id" :id="section.headerAnchor">
        <AppearContentScroll
          :image="section.image"
          :header="section.header"
          :twist="section.id%2===0"
        >
          <template v-slot:content>
            <div class="pt-sm-0 pt-4">
              <h3
                  :class="[{'text-h4': !$vuetify.breakpoint.mobile, 'text-h5': $vuetify.breakpoint.mobile}]"
              >
                {{section.content.headline}}
              </h3>
              <v-list class="" dense>
                <v-list-item class="py-0" v-for="(item, i) in section.content.items" :key="i">
                  <v-list-item-icon>
                    <v-icon color="success">mdi-check</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="">
                    {{item}}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
          </template>
        </AppearContentScroll>
      </section>
      <section id="contact">
        <h2 class="text-h2 text-center">Contact us</h2>
        <Contact class="justify pa-sm-12 ma-sm-12 mx-sm-auto pa-4 ma-4 mx-auto contact-form"></Contact>
      </section>

    </v-main>
    <Footer />
  </div>
</template>

<script>
import AppBar from '@/components/AppBar';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';
import ParallaxAlumnier from '@/components/sections/ParallaxAlumnier';
import AppearContentScroll from '@/components/sections/AppearContentScroll';
import AppearBoxesScroll from '@/components/sections/AppearBoxesScroll';

const sectionsContent = [
  {
    id:1,
    header: 'Highlights',
    headerAnchor: 'highlights',
    image: 'conference.jpg',
    content: {
      headline: 'Your alumni always updated and reachable',
      // subtext: 'Alumnier tracks your alumni profiles and gives you updated information to ',
      items: [
        'Get real and updated information abour your former students ir real time',
        'Segment your former students by location, academic background, jobs, or any other topic',
        'Look for specific profiles among your former students',
        'Improve your campaign results using segmented datasets when emailing your former students',
      ]
    }
  },
  {
    id:2,
    header: 'Features',
    headerAnchor: 'features',
    image: 'one-platform.jpg',
    content: {
      headline: 'One platform to find\'em all',
      items: [
        'You can access the plattform 24x7 with security and privacy',
        'Just login and begin creating datasets to launch campaigns',
        'Powerful filter-system that will find ANY former student that fits your needs',
        'Export your date to a .csv file or to JSONs (if you need to import the data to other CRMs)',
      ]
    }
  },
  {
    id:3,
    header: 'Main benefits',
    headerAnchor: 'main-benefits',
    image: 'graph-growing.jpg',
    content: {
      headline: 'Improve your marketing results, increase your Alumni engagement',
      items: [
        'Having all the data updated, no Alumni will receive any unwanted email',
        'Knowing your Alumni backgrounds, you will target your campaigns and improve your Conversion Rates',
        'Filtering your Alumni you will find former students that fit your requirements (when looking for teachers, speakers or any kind of collaboration)',
        'No need to invest half of your month looking at linkedin profiles, invest your time where you are more productive and increase sales and brand image'
      ]
    }
  }
];

export default {
  name: 'AppAlumnier',

  components: {
    AppBar,
    ParallaxAlumnier,
    AppearContentScroll,
    AppearBoxesScroll,
    Contact,
    Footer
  },

  data: () => ({
    sectionsContent: sectionsContent.slice(1),
    singleSection: sectionsContent[0],
    sectionsHeaders: sectionsContent.map(e => ({name: e.header, anchor: e.headerAnchor}))
  }),
  mounted() {
    this.sectionsHeaders.push({name: 'Contact', anchor: 'contact'});
  }
};
</script>

<style lang="css" scoped>
  .contact-form {
    max-width: 750px
  }
  section:not(:first-child){
    padding-top: 50px;
  }
</style>
